import {useCallback, useMemo} from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {Select, SelectChangeEvent} from '@mui/material';
import {
  CountryData,
  defaultCountries,
  parseCountry,
} from 'react-international-phone';

import {MENU_PROPS, SELECT_STYLE} from './constants';
import {CountryMenuItem} from './CountryMenuItem';
import {CountrySelectValue} from './CountrySelectValue';

interface CountrySelectProps {
  countries?: CountryData[];
  country: {iso2: string};
  setCountry: (country: string) => void;
  id?: string;
  disabled?: boolean;
}

export function CountrySelect({
  countries = defaultCountries,
  country,
  setCountry,
  id,
  disabled = false,
}: CountrySelectProps) {
  const isDisabled = useMemo(
    () => disabled || countries?.length < 2,
    [disabled, countries],
  );

  const handleCountryChange = useCallback(
    (event: SelectChangeEvent<string>) => {
      setCountry(event.target.value);
    },
    [setCountry],
  );

  return (
    <Select
      id={id}
      variant="outlined"
      IconComponent={KeyboardArrowDownIcon}
      MenuProps={MENU_PROPS}
      sx={SELECT_STYLE}
      value={country.iso2}
      disabled={isDisabled}
      onChange={handleCountryChange}
      renderValue={value => {
        const selectedCountry = countries.find(
          c => parseCountry(c).iso2 === value,
        );
        return <CountrySelectValue country={parseCountry(selectedCountry)} />;
      }}>
      {countries.map(c => {
        const parsedCountry = parseCountry(c);
        return (
          <CountryMenuItem
            key={parsedCountry.iso2}
            value={parsedCountry.iso2}
            country={parsedCountry}
          />
        );
      })}
    </Select>
  );
}
